module.exports = __webpack_public_path__ + "img/5-2-silver.d64630f0.jpg";